import Login from './admin/login';
import CF7 from './admin/cf7';
import AcfSvgField from './admin/acf-svg-field';

jQuery(function() {
	Login.init();
	CF7.init();
	AcfSvgField.init();
});
